<template>
  <label
    class="z-input-field"
  >
    <p class="z-text z-input-field__label" v-if="label">
      {{ label }}
      <help-icon
        :tooltip="helpText"
        v-if="helpText"
      />
    </p>

    <div
      class="z-input"
      :class="{
        'z-input--has-error': error,
        'z-input--is-disabled': isDisabled,
      }"
    >
      <input
        class="z-input__field"
        :type="type"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur', $event)"
        v-bind="$attrs"
      >
    </div>

    <strong class="z-caption z-input-field__error z-caption--danger" v-if="error">
      {{ errorMessage }}
    </strong>
  </label>
</template>

<script>
import HelpIcon from 'components/help-icon';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: undefined,
    },
  },
  components: {
    HelpIcon,
  },
  computed: {
    isDisabled() {
      return this.$attrs.disabled !== undefined && this.$attrs.disabled !== false;
    },
    error() {
      return this.errorMessage && this.errorMessage.length > 0;
    },
  },
};
</script>
